import useSWR from "swr";
import type { Campaign } from "@/lib/core/types";

const fetcher = async (url: string) => {
  const res = await fetch(url);
  if (res.status === 409) {
    // Archived campaign — the same sentinel string `fetchCampaign` throws
    // (src/api/campaigns.ts) so downstream detection is uniform (D2). The
    // real in-game read path (this hook, consumed by TtrpgApp) does NOT go
    // through `fetchCampaign` — it has its own fetcher, so the 409 → typed
    // error mapping has to be duplicated here.
    throw new Error("campaign_archived");
  }
  if (!res.ok) {
    throw new Error("Failed to fetch campaign data");
  }
  return res.json();
};

export function useCampaignSync(campaignId: string) {
  // 1. SWR for Initial Fetch & Polling Fallback
  const {
    data: campaign,
    mutate,
    error,
  } = useSWR<Campaign>(
    campaignId ? `/api/campaigns/${campaignId}` : null,
    fetcher,
    {
      refreshInterval: 5000, // Polling fallback (5s)
      revalidateOnFocus: true,
    }
  );

  return {
    campaign,
    mutate,
    isLoading: !campaign && !error,
    error,
  };
}
